export default {
    CustomerList: {
        ChooseCustomer: 'Choisir le client',
    },

    Customer: {
        SafesOnline: 'Automates connectés',
        CurrentBalance: 'Encaisse actuelle',
        DailySales: 'Ventes journalières',
        ActiveWarnings: 'Alertes actives',
        Of: 'OF',
        In: 'EN',
        Branches: 'SITES',
    },

    Branch: {
        ExportTransactions: "Exporter les transactions",
        ManageOperators: "Gérer les opérateurs",
        ShowOnMap: "Montrer sur la carte",
        CurrentBalance: "Encaisse actuelle",
        DailySales: 'Alertes actives',
        MainCurrency: 'Devise principale',
        TransactionDays: "Jours de transactions",
    },

    BranchList: {
        Name: 'Nom',
        Status: 'Statut',
        BalanceAmount: 'Encaisse',
        BalanceCurrency: 'Encaisse de devise',
        LastBalance: 'Mis à jour',
        Branches: 'Sites',
    },

    BranchListFilter: {
        Branches: 'Centres-forts',
        SearchCriteria: 'Recherche centre-fort...',
    },

    Chart: {
        Sales: 'Ventes',
        Pickup: 'Ramassage',
        Balance: 'Encaisse',
        Difference: 'Différence',
        Confirmed: 'Confirmé',
        DepositsAndPickups: 'Dépôts & Ramasssages',
        NoDataAvailable: 'Pas de données disponibles',
        SafebagBalance: 'Solde Safebag',
        RecyclableBalance: 'Solde Recycler',
        ManualDepositBalance: 'Solde depot manuel',
        OverflowBalance: 'Solde trop-pleinOverflow balance'
    },

    ChartDenominations: {
        Deposited: 'Deposé',
        Recyclable: 'Recyclable',
        Denominations: 'Coupures',
        NoDataAvailable: 'Pas de données disponibles'
    },

    ChartTransactionDay: {
        ProcessedSales: 'Dépôt traité',
        UnprocessedSales: 'Dépôt non traité',
        SalesOut: 'Distribution',
        SalesPerHour: 'Vente par heure'
    },

    CustomerHeader: {
        ShowOnMap: 'Montrer sur la carte',
        Branches: 'Sites',
        Branch: 'Site',
        ExportTransactions: 'Exporter les transactions',
    },

    DeviceStatus: {
        AllOk: 'Tout est ok',
    },

    DeviceStatusList: {
        Safes: 'Coffres',
    },

    ExportForm: {
        ExportTransactions: 'Exporter les transactions',
        Cancel: 'Annuler',
        Export: 'Exporter',
        FromDate: 'Date de début',
        Time: 'Heure',
        EndDate: 'Date de fin'
    },

    ForgotPasswordForm: {
        ForgotHeader: 'Mot de passe oublié ?',
        ForgotText: 'Entrez votre email ci-dessous et cliquez sur le bouton SVP. Vous recevrez un email avec des instructions approfondies.',
        LoginLink: 'Retour à la connexion',
        EmailAddress: 'Adresse e-mail',
        Submit: 'Envoyer e-mail',
        ErrorMessage: "Nous étions dans l'incapacité d'envoyer votre requête au serveur"
    },

    LoginPage: {
        LoginHeader: 'Bienvenue',
        LoginText: 'Connectez-vous ci-dessous en utilisant votre email et mot de passe',
        LoginForgot: 'Mot de passe oublié ?',
        Username: 'EMAIL',
        Password: 'MOT DE PASSE',
        Login: 'Connexion'
    },

    ResetPasswordPage: {
        ResetHeader: 'Réinitialiser le mot de passe',
        ResetText: 'Entrez votre nouveau mot de passe.'
    },

    Drawer: {
        Dashboard: 'Tableau de bord',
        SwitchCustomer: 'Changer de client',
        MyProfile: 'Mon profil',
        Report: 'Rapport',
        Logout: 'Déconnexion'
    },

    OperatorForm: {
        UserId: 'Identifiant utilisateur',
        FirstName: 'Prénom',
        LastName: 'Nom',
        Pin: 'Pin',
        Save: 'Sauvegarder',
        Delete: 'Supprimer',
        Operator: 'Opérateur'
    },

    OperatorList: {
        AddOperator: 'Ajouter un opérateur',
        Operators: 'Opérateurs',
        Name: 'Nom',
    },

    Profile: {
        Profile: 'Profil',
        Name: 'Nom',
        Language: 'Langage',
        Password: 'Mot de passe',
        ConfirmPassword: 'Confirmer le mot de passe',
        Update: 'Mis à jour'
    },

    ResetPasswordForm: {
        NewPassword: 'Nouveau mot de passe',
        ConfirmPassword: 'Confirmer le mot de passe',
        Submit: 'Soumettre'
    },

    InviteUserForm: {
        InviteHeader: 'Utilisateur invité',
        InviteText: "Merci de remplir vos données dans votre profil et d'appuyer sur Sauvegarder afin de pouvoir vous connecter.",
        Name: 'Nom',
        Language: 'Langue',
        NewPassword: 'Nouveau mot de passe',
        ConfirmPassword: 'Confirmer le mot de passe',
        Submit: 'Sauvegarder'
    },

    TransactionList: {
        Type: 'Type',
        Operator: 'Opérateur',
        When: 'Quand',
        Amount: 'Montant',
        Currency: 'Devise',
        Transactions: 'Transactions',
        Device: 'Equipement',
        SalesDay: 'Date de vente',
        HoverDeposit: 'Dépôt',
        HoverSalesIn: 'Vente en entrée',
        HoverSalesOut: 'Distribution',
        HoverManualDeposit: 'Dépôt manuel',
        HoverCollection: 'Collecte',
        HoverCollectionNotes: 'Collecte de billets',
        HoverCollectionCoins: 'Collecte de pièces',
        HoverCollectionEnvelope: 'Collecte of dépôts manuels',
        HoverCollectionOK: 'Collecte confirmée',
        HoverCollectionNotesOK: 'Collecte de billets confirmée',
        HoverCollectionCoinsOK: 'Collecte de pièces confirmée',
        HoverCollectionEnvelopeOK: 'Collecte de dépôts manuels confirmée',
        HoverCollectionNOK: 'Différence de collecte',
        HoverCollectionNotesNOK: 'Différence de collecte de billets',
        HoverCollectionCoinsNOK: 'Différence de collecte de pièces',
        HoverCollectionEnvelopeNOK: 'Différence de collecte de dépôts manuels',
        HoverDrain: 'Enlèvement',
        HoverRefill: 'Rechargement',
        HoverExchange: 'Echange',
        HoverExchangeIn: 'Echange en entrée',
        HoverExchangeOut: 'Echange en sortie',
        HoverCounterfeit: 'Faux',
        HoverInternal: 'Transaction interne',
        HoverNOP: "Pas d'opération"
    },

    TransactionDayList: {
        Date: "Date",
        Sales: "Ventes",
        Pickup: "Ramassage",
        Balance: "Solde",
        TransactionDays: "Jours de transactions"
    },

    TransactionDay: {
        Date: "Date",
        Sales: "Vente",
        Pickup: "Ramassage",
        Balance: "Solde",
        TransactionDays: "Jours de transactions",
        ExportTransactions: "Exporter les transactions",
    },

    TransactionDatePicker: {
        Date: 'Date'
    },

    ReportForm: {
        Title: "Rapport périodique",
        Enabled: 'Activer le rapport périodique',
        ReportSaved: 'Rapport enregistré',
        NextExecution: 'Exécution du prochain état',
        Reports: 'Rapports',
        Report: 'Rapport',
        ReportTRANSACTION: 'Rapport de transaction',
        ReportBALANCE: 'Rapport des ventes',
        ReportOPERATOR: 'Rapport opérateur',
        ReportTypeCSV: 'CSV',
        ReportTypeEXCEL: 'Excel',
        ReportTypePDF: 'PDF',
        Execution: 'Exécution',
        ExecutionTypeMonth: 'Une fois par mois',
        ExecutionTypeWeekDay: 'En semaine',
        ExecutionDay: 'Jour en mois',
        ExecutionTime: "Temps d'exécution",
        ExecutionTimePattern: '00:00',
        ExecutionWeekDayMONDAY: 'Lundi',
        ExecutionWeekDayTUESDAY: 'Mardi',
        ExecutionWeekDayWEDNESDAY: 'Mercredi',
        ExecutionWeekDayTHURSDAY: 'Jeudi',
        ExecutionWeekDayFRIDAY: 'Vendredi',
        ExecutionWeekDaySATURDAY: 'Samedi',
        ExecutionWeekDaySUNDAY: 'Dimanche',
        Content: 'Contenu',
        ContentTypeSinceLast: 'Tous depuis le dernier rapport',
        ContentTypeRelative: 'Relatif',
        ContentRelativeType: 'Passé : ',
        ContentRelativeTypeDAY: 'Jours',
        ContentRelativeTypeWEEK: 'Semaines',
        ContentRelativeTypeMONTH: 'Mois',
        ErrorFieldRequired: 'Champ obligatoire!',
        ErrorSelectAtLeastOneDay: 'Sélectionnez au moins un jour.',
        ErrorFormat: 'Il doit être dans ce format : 00:00',
        ErrorEnableAtLeastOneReport: 'Activer au moins un rapport',
        Update: 'Sauver'
    }
};


// WEBPACK FOOTER //
// ./src/lib/i18n/fr.js